export const lensAddresses = {
  accountLens: "0x2c6337ED09A0f9fd4f03072b6671964eb509DCc6",
  eulerEarnVaultLens: "0x9A5da16466B92FfDDf2031e6D5fD4a8842D55A46",
  irmLens: "0xD4Ba314ddC8a6EB4B288a1325775694205Fa29d6",
  oracleLens: "0x35d1F7Dc15fE13578bC7d437ED55d918DC98ac21",
  utilsLens: "0x296fB3F4C9d5e825e71f34b18d000651c1f44C55",
  vaultLens: "0x06Ff0E0bCa6e6eFB7E32e3e447217A892cd9b48b",
} as const
